module.exports = __webpack_public_path__ + "img/keranjang-icon.e0f8d371.svg";